import { render } from "./Prodi.vue?vue&type=template&id=2be8fbfa"
import script from "./Prodi.vue?vue&type=script&lang=js"
export * from "./Prodi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__